export const init = ($target) => {
	const $distRatesSelects = $target.find('.js-distrate-select'),
		$formResults = $target.find('.js-form-result');

	function distributionRateChanged(params) {
		const $this = $(this);
		const $result = $this.closest('.distribution-rate').find('.js-form-result');

		if ($this.val() === 'js-choose') {
			$result.empty();
		} else {
			$.ajax({
				url: $this.val(),
				success: function (response) {
					$result.html(response);
				},
			});
		}
	}

	$distRatesSelects.on('change', distributionRateChanged);

	$formResults.each(function () {
		this.addEventListener('contentload', function () {
			$(this).find('.js-distrate-select').on('change', distributionRateChanged);
		});
	});
};
